import styled from 'styled-components';

export const StyledCleaningReportListExact = styled.div``;
